import script from "./TeamManagementSidebar.vue?vue&type=script&lang=ts&setup=true"
export * from "./TeamManagementSidebar.vue?vue&type=script&lang=ts&setup=true"

import "./TeamManagementSidebar.vue?vue&type=style&index=0&id=47b959fd&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-47b959fd"]])

export default __exports__